import { render, staticRenderFns } from "./stopUsingCancelPopup.vue?vue&type=template&id=2670e608&scoped=true"
import script from "./stopUsingCancelPopup.vue?vue&type=script&lang=js"
export * from "./stopUsingCancelPopup.vue?vue&type=script&lang=js"
import style0 from "./stopUsingCancelPopup.vue?vue&type=style&index=0&id=2670e608&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2670e608",
  null
  
)

export default component.exports